// extracted by mini-css-extract-plugin
export default {"header":"header_header__HOCtl","header__wing":"header_header__wing__qOdg9"};